import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[AIAC ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const missingConfig = (() => { try { return !['http:', 'https:'].includes(new URL(backendUrl).protocol); } catch { return true; } })();
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
          padding: '2rem',
          background: '#fafaf9',
        }}>
          <div style={{ maxWidth: 560, background: 'white', border: '1px solid #e5e7eb', borderRadius: 16, padding: 32, boxShadow: '0 1px 3px rgba(0,0,0,.05)' }}>
            <h1 style={{ fontSize: 20, fontWeight: 700, color: '#111827', marginBottom: 12 }}>
              L'app non si è avviata correttamente
            </h1>
            {missingConfig ? (
              <div style={{ fontSize: 14, color: '#374151', lineHeight: 1.6 }}>
                <p><b>Configurazione mancante:</b> la variabile <code>REACT_APP_BACKEND_URL</code> non è stata impostata al momento del build.</p>
                <p style={{ marginTop: 8 }}>Se stai deployando su <b>Railway</b>:</p>
                <ol style={{ marginTop: 8, paddingLeft: 20 }}>
                  <li>Servizio frontend → <b>Variables</b></li>
                  <li>Aggiungi <code>REACT_APP_BACKEND_URL</code> = URL del tuo backend (es. <code>https://backend-xxx.up.railway.app</code>)</li>
                  <li>Clicca <b>Redeploy</b> (non basta il restart — le var React sono compilate nel bundle)</li>
                </ol>
              </div>
            ) : (
              <div style={{ fontSize: 14, color: '#374151', lineHeight: 1.6 }}>
                <p>Si è verificato un errore imprevisto. Ricarica la pagina per riprovare.</p>
                <details style={{ marginTop: 12 }}>
                  <summary style={{ cursor: 'pointer', color: '#6b7280' }}>Dettagli tecnici</summary>
                  <pre style={{ marginTop: 8, fontSize: 12, background: '#f3f4f6', padding: 12, borderRadius: 6, overflow: 'auto' }}>
                    {this.state.error?.toString()}
                  </pre>
                </details>
              </div>
            )}
            <button
              onClick={() => window.location.reload()}
              style={{ marginTop: 20, padding: '10px 20px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, cursor: 'pointer', fontWeight: 600 }}
            >
              Ricarica la pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
